<template>
  <div class="py-4">
    <p v-if="!isCompleteOrError" class="text-xs text-center text-gray-500">
      powered by
      <a
        class="text-xs"
        href="https://www.jarvisanalytics.com/"
        target="_blank"
        rel="noopener noreferrer"
        >JARVIS ANALYTICS</a
      >
    </p>
    <p v-else class="text-xs text-center text-gray-500">
      powered by
      <a
        class="text-xs"
        href="https://www.jarvisanalytics.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg-jarvis class="mx-auto mt-4"></svg-jarvis>
      </a>
    </p>
  </div>
</template>

<script>
import SvgJarvis from "@/components/Svg/SvgJarvis";

export default {
  components: {
    SvgJarvis,
  },
  computed: {
    isCompleteOrError() {
      return this.$store.state.isComplete || this.$store.state.isError;
    },
  },
};
</script>
